import { createContext } from 'react';

export interface SidePanelRegistration {
  id: string;
  defaultWidth: number;
  resizable: boolean;
}

export interface SidePanelContextValue {
  register: (registration: SidePanelRegistration) => void;
  unregister: (id: string) => void;
  slotElement: HTMLElement | null;
}

export const SidePanelContext = createContext<SidePanelContextValue | null>(null);
